import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Input, Label } from '@ipc/ipc-components';
import styled from 'styled-components';
import {
  getData,
  getColumns, getIsLoading,
  getCheckedRows,
} from '../redux/selectors/ManualPreadviceTransactionsSelectors';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getClickedRowOnTable } from '../../../../../common/tables/reducers/selectors/ListTableSelectors';
import PreAdviceTransactionsHistoryContainer from '../../transactions-history/pre-advice/containers/PreAdviceTransactionsHistoryContainer';
import ManualPreadviceTransactionsCreate from '../create/containers/ManualPreadviceTransactionsCreate';
import ManualPreadviceTransactionsDelete from '../delete/containers/ManualPreadviceTransactionsDelete';
import { postManualPreadviceTransactionsApplyRequestActionCreator } from '../apply/redux/actions/ManualPreadviceTransactionsApplyActions';
import { getUserRole } from '../../../../../common/user/redux/selectors/UserDataSelectors';
import { ManualPreadviceTransactionsStyle } from './ManualPreadviceTransactionsContainer.styles';
import downloadTypes from '../../../../../common/tables/excel/DownloadTypes';
import { TransactionsStyle } from '../../component/Transactions.styles';

const StyledComponentContainer = styled.div`${ManualPreadviceTransactionsStyle}`;
StyledComponentContainer.displayName = 'StyledComponentContainer';

class ManualPreadviceTransactionsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDayCount: 10,
      showCreateModal: false,
      showDeleteModal: false,
    };
    this.clickApplyButton = this.clickApplyButton.bind(this);
    this.createTransaction = this.createTransaction.bind(this);
    this.bulkApplySavedStatusToOpen = this.bulkApplySavedStatusToOpen.bind(this);
    this.deleteTransaction = this.deleteTransaction.bind(this);
    this.refreshTableData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.clickedRow !== prevProps.clickedRow) {
      this.refreshTableData();
    }
  }

  showCreateFormModal = () => {
    this.setState({
      showCreateModal: true,
    });
  }

  hideCreateFormModal = () => {
    this.setState({
      showCreateModal: false,
    });
  }

  showDeleteFormModal = () => {
    this.setState({
      showDeleteModal: true,
    });
  }

  hideDeleteFormModal = () => {
    this.setState({
      showDeleteModal: false,
    });
  }

  enterPressed = (e) => {
    const code = e.keyCode || e.which;
    if (code === 13) {
      this.clickApplyButton();
    }
  }

  refreshTableData = () => {
    this.props.tableLoadData(
      {
        tableId: TableDefinitions.MANUAL_PREADVICE_TRANSACTIONS.id,
      },
      this.props.appContext.appContext,
      {
        impcCode: this.props.clickedRow.impc,
        selectedDays: this.state.selectedDayCount,
      },
    );
  }

  handleChange(e) {
    this.setState({
      selectedDayCount: e.target.value,
    });
  }

  createTransaction() {
    this.setState({
      showCreateModal: true,
    });
  }

  deleteTransaction() {
    this.setState({
      showDeleteModal: true,
    });
  }

  clickApplyButton() {
    this.refreshTableData();
  }

  async bulkApplySavedStatusToOpen() {
    const transactionIds = [];
    this.props.checkedRows.map((index) => (index.status === 'SAVED' ? transactionIds.push(index.id) : transactionIds));
    await this.props.postManualPreadviceTransactionsApplyRequestActionCreator(
      this.props.appContext,
      transactionIds,
    );
    this.refreshTableData();
  }

  render() {
    const {
      showCreateModal,
      showDeleteModal,
    } = this.state;
    return (
      <TransactionsStyle>
        <Label>
          Show transactions for the last
          <Input
            className="last-day-input"
            value={this.state.selectedDayCount}
            onChange={(e) => this.handleChange(e)}
            onKeyPress={this.enterPressed}
          />
          days
        </Label>
        <Button className="action-buttons" onClick={this.clickApplyButton}>
          Apply
        </Button>
        {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
        || this.props.userRole.includes('IPC_TRAY_MANAGER')
        || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Button className="action-buttons" onClick={this.createTransaction}>
            Add New Manual Pre-advice Adjustment
          </Button>
        )}
        {this.props.checkedRows !== undefined && (this.props.checkedRows.filter((index) => (index.status === 'SAVED')).length !== 0
          || this.props.checkedRows.filter((index) => (index.status === 'OPEN')).length !== 0
          || this.props.checkedRows.filter((index) => (index.status === 'SERVICED_IN')).length !== 0
          || this.props.checkedRows.filter((index) => (index.status === 'SERVICED_OUT')).length !== 0)
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Button className="action-buttons primary-button-false" onClick={this.deleteTransaction}>
            DELETE
          </Button>
        )}
        {this.props.checkedRows !== undefined && this.props.checkedRows.filter((index) => (index.status === 'SAVED')).length !== 0
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Button className="action-buttons primary-button-false" onClick={this.bulkApplySavedStatusToOpen}>
            APPLY MANUAL PRE-ADVICE ADJUSTMENT
          </Button>
        )}
        <StyledComponentContainer>
          <ListTable
            listId={TableDefinitions.MANUAL_PREADVICE_TRANSACTIONS.id}
            loading={this.props.isLoading}
            columns={this.props.columns}
            data={this.props.data}
            keyField="id"
            selectCheckbox
            downloadType={downloadTypes.EXCEL}
            getSubComponentProps={(row) => (
              <div style={{ padding: '20px' }}>
                <PreAdviceTransactionsHistoryContainer
                  row={row}
                  refreshTransactions={this.refreshTableData}
                />
              </div>
            )}
          />
        </StyledComponentContainer>
        {showCreateModal && (
          <ManualPreadviceTransactionsCreate
            closeDialog={this.hideCreateFormModal}
            openDialog={this.showCreateFormModal}
            row={this.props.clickedRow}
            refreshTransactions={this.refreshTableData}
          />
        )}
        {showDeleteModal && (
          <ManualPreadviceTransactionsDelete
            closeDialog={this.hideDeleteFormModal}
            openDialog={this.showDeleteFormModal}
            row={this.props.checkedRows}
            refreshTransactions={this.refreshTableData}
          />
        )}
      </TransactionsStyle>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
    checkedRows: getCheckedRows(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
  };
}

ManualPreadviceTransactionsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.shape),
  checkedRows: PropTypes.arrayOf(PropTypes.object),
  postManualPreadviceTransactionsApplyRequestActionCreator: PropTypes.func,
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  postManualPreadviceTransactionsApplyRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ManualPreadviceTransactionsContainer);
